import styles from './LineItems.module.scss';

import React from 'react';
import cx from 'clsx';
import { Icon } from 'components/Icon';
import { useTranslation } from 'react-i18next';
import { LineItem, GiftCardLineItem } from './LineItem/LineItem';
import { DetailedCartItem } from 'hooks/context/cart';
import { GiftCardItem } from 'olo-service';

export type LineItemsProps = React.HTMLProps<HTMLUListElement> & {
  items?: DetailedCartItem[];
  runningItems?: DetailedCartItem[];
  giftCardItems?: GiftCardItem[];
  onClick?: () => void;
  readOnly?: boolean;
};

export const LineItems: React.FC<LineItemsProps> = ({
  className, items = [], giftCardItems=[], runningItems=[], onClick, readOnly, ...props
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ul className={cx(styles.wrapper, className)} data-testid="cart-items" {...props}>
        {!items.length && !giftCardItems.length && !readOnly && (
          <li className={cx(styles.empty, 'h1')} data-testid="cart-items-empty">
            <Icon aria-hidden={true} name="cart" size={48} />
            {t('cart.empty')}
          </li>
        )}
        {items.map(item => (
          <li key={item.cartId}>
            <LineItem onClick={onClick} item={item} readOnly={readOnly} />
          </li>
        ))}
        {giftCardItems.map((item, index) => (
          <li key={index}>
            <GiftCardLineItem onClick={onClick} index={index} item={item} readOnly={readOnly} />
          </li>
        ))}
        {runningItems.length !== 0 &&
        <>
          <p className={styles.subtitle} data-testid="running-order-line-subtitle">{t('cart.alreadySentToKitchen')}</p>
            {runningItems.map(item => (
              <li key={item.cartId}>
                <LineItem item={item} readOnly={true} />
              </li>
            ))}
        </>
        }
      </ul>
    </>
  );
};
